import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const toKey = (b64) => { const s = (b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"); const raw = atob(s); return Uint8Array.from([...raw].map((c) => c.charCodeAt(0))); };

// Web Push opt-in for highlight alerts. state: unsupported | denied | prompt | subscribed
export function usePushAlerts(token) {
  const supported = typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  const [state, setState] = useState(() => (!supported ? "unsupported" : Notification.permission === "denied" ? "denied" : "prompt"));
  const [busy, setBusy] = useState(false);
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    if (!supported || !token || Notification.permission !== "granted") return;
    navigator.serviceWorker.ready.then((reg) => reg.pushManager.getSubscription()).then((sub) => { if (sub) setState("subscribed"); }).catch(() => {});
  }, [supported, token]);

  const enable = useCallback(async () => {
    if (!supported) return false;
    setBusy(true);
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") { setState(perm === "denied" ? "denied" : "prompt"); return false; }
      const reg = await navigator.serviceWorker.ready;
      const { data } = await axios.get(`${API}/push/vapid-public-key`);
      const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) }));
      await axios.post(`${API}/push/subscribe`, { subscription: sub.toJSON() }, auth);
      setState("subscribed");
      return true;
    } catch (e) {
      return false;
    } finally { setBusy(false); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supported, token]);

  return { state, busy, enable };
}
